import customForm from './customForm';
import richTextForm from './richTextForm';
import imageList from './imageList';
import colorPicker from './colorPicker';
import channelDis from './channelDis';
import uploadImage from './uploadImage';
import treeList from './treeList';
import jsonEditor from './jsonEditor';
import itemList from './itemList';
import textBox from './textBox';
import numberInput from './numberInput';
import textareaBox from './textareaBox';
import wangeditorRichtext from './wangeditorRichtext';
import imgItem from './imgItem';
import itemListV2 from './itemListV2';
const components = [
    richTextForm,
    imageList,
    customForm,
    colorPicker,
    channelDis,
    uploadImage,
    treeList,
    jsonEditor,
    itemList,
    textBox,
    numberInput,
    textareaBox,
    wangeditorRichtext,
    imgItem,
    itemListV2
];
const install = function(Vue, opts = {}) {
    components.map(component => {
        Vue.component(component.name, component);
    });
};
export default  {
    richTextForm,
    imageList,
    customForm,
    colorPicker,
    channelDis,
    uploadImage,
    treeList,
    jsonEditor,
    textBox,
    numberInput,
    textareaBox,
    wangeditorRichtext,
    imgItem,
    itemListV2,
    install
};


// WEBPACK FOOTER //
// ./src/components/compEditForm/index.js